import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ArticlesPage from "./pages/ArticlesPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminEntry from "./pages/admin/AdminEntry";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { AuthProvider } from "./lib/auth";
import { ContentProvider } from "./lib/content";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    document.documentElement.setAttribute("dir", "rtl");
    document.documentElement.setAttribute("lang", "fa");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <AuthProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Layout><HomePage /></Layout>} />
              <Route path="/products" element={<Layout><ProductsPage /></Layout>} />
              <Route path="/products/:slug" element={<Layout><ProductDetailPage /></Layout>} />
              <Route path="/articles" element={<Layout><ArticlesPage /></Layout>} />
              <Route path="/articles/:slug" element={<Layout><ArticleDetailPage /></Layout>} />
              <Route path="/about" element={<Layout><AboutPage /></Layout>} />
              <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
              <Route path="/admin" element={<Layout><AdminEntry /></Layout>} />
              <Route path="/admin/dashboard/*" element={<Layout><AdminDashboard /></Layout>} />
            </Routes>
          </AuthProvider>
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}
